import React from 'react';
import { Row, Col, Card, Collapse } from 'react-bootstrap';

import { render_marked_text } from '../utils/HiddenText';

function AnswerReadiness({
	analysis_results,
	show_answer,
	set_show_answer
}){

	const render_answer_readiness_boolean = (label, value)=>{
		return(
			<div className={"answer-bool-item " + (value ? "answer-bool-true" : "answer-bool-false")}>
				<span className="answer-bool-icon"></span>
				<span className="answer-bool-label">{label}</span>
			</div>
		);
	};

	const render_answer_readiness_section = ()=>{
		const data = analysis_results.answer_readiness;
		if(!data){
			return;
		}

		// <p className="answer-readiness-found">Answers Found</p>
		return(
			<Card className="analysis-results-card answer-readiness-card">
				<h3 className="answer-readiness-title" 
					onClick={()=>set_show_answer(!show_answer)} 
					style={{cursor:'pointer'}}>
					Answer Readiness {show_answer ? "▲" : "▼"}
				</h3>
				<p className="answer-readiness-desc">How easily this page can be used to provide direct, high-quality answers for AI search tools.</p>
				<Collapse in={show_answer}>
				<div>
				<Row>
					<Col md={4}>
						<div className="answer-bool-list">
							 
							{render_answer_readiness_boolean("Direct answers on the page", data.has_direct_answers)}
							{render_answer_readiness_boolean("FAQ section present", data.has_faq)}
							{render_answer_readiness_boolean("Question-style headings", data.has_question_headings)}
						</div>
					</Col>

					<Col md={8}>
						<div className="answer-sentences-list">
							<div className="entity-section-heading">Answers detected</div>
							{data.extractable_sentences.map((text, index)=>{
								const question = (Array.isArray(data.answered_questions) && data.answered_questions[index]) ? data.answered_questions[index] : null;
								return(
									<div key={index} className="answer-sentence-box">
										{question ? <div className="answer-question">{question}</div> : null}
										<div className="answer-sentence">{render_marked_text(text, analysis_results)}</div>
									</div>
								);
							})}
						</div>
					</Col>
				</Row>
				</div>
				</Collapse>
			</Card>
		);
	};

	if(!analysis_results || !analysis_results.answer_readiness){
		return null;
	}

	return render_answer_readiness_section();
}

export default AnswerReadiness;
